export default "__VITE_ASSET__hIx9mjy$__"